import { usePermanentDeleteExpeditionBo } from "@/api/expedition.api";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { getExpeditionIdentifier } from "@/lib/expedition.util";
import {
  GetAllExpeditionBoResponseDtoExpedition,
  GetOneExpeditionBoResponseDto,
} from "@/types/api/api-types";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  expedition: GetAllExpeditionBoResponseDtoExpedition | GetOneExpeditionBoResponseDto;
};

export const PermanentDeleteModal = ({ open, onClose, expedition }: Props) => {
  const { t } = useTranslation(["boExpeditions", "common"]);
  const { mutateAsync: permanentDeleteExpeditionBo, isPending: isPermanentDeletePending } =
    usePermanentDeleteExpeditionBo();

  const identifier = getExpeditionIdentifier(expedition) ?? "";

  const handleConfirm = async () => {
    await permanentDeleteExpeditionBo(expedition.id);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      dismissible={!isPermanentDeletePending}
      title={t("permanentDeleteModal.title", { identifier })}
      description={t("permanentDeleteModal.description", { identifier })}
      footer={
        <div className="flex w-full flex-row justify-between gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            className="flex-1"
            disabled={isPermanentDeletePending}
          >
            {t("common:actions.cancel")}
          </Button>
          <Button
            type="button"
            variant="default"
            onClick={handleConfirm}
            className="flex-1"
            disabled={isPermanentDeletePending}
          >
            {isPermanentDeletePending ? (
              <Loader2 className="animate-spin" />
            ) : (
              t("permanentDeleteModal.submit")
            )}
          </Button>
        </div>
      }
    />
  );
};
